import React from "react";
import { Navigate } from "react-router-dom";
import { global } from "@shared/libs/Global";

const ALLOWED = new Set(["SNADMIN", "SYSTEM"]);

export default function RequireAdmin({
  children,
}: {
  children: React.ReactNode;
}) {
  const { userInfo } = global();
  const username = (userInfo.cd_user || userInfo.nm_user || "").toUpperCase();
  const isAllowed = ALLOWED.has(username);

  return isAllowed ? <>{children}</> : <Navigate to="/403" replace />;
}
